import { Card, CardBody, Col } from "reactstrap";
import { H3, P } from "../../../AbstractElements";
import { ARTICALS_DATA } from "../../../Data/Knowledgebase";

const Articals = () => {
  return (
    <>
      {ARTICALS_DATA.map((item) => (
        <Col xl="4" sm={item.sm} key={item.id}>
          <Card className="bg-subheader">
            <CardBody>
              <div className="d-flex faq-widgets">
                <div className="flex-grow-1">
                  <H3>{item.title}</H3>
                  <P>{item.paragraph}</P>
                </div>
                {item.icon}
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};
export default Articals;
